"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledReview = exports.StyledLink = exports.StyledDiv = exports.Stars = exports.Container = void 0;
var _Star = _interopRequireDefault(require("@tvg/fuse-icons/lib/Star"));
var _StarFilled = _interopRequireDefault(require("@tvg/fuse-icons/lib/StarFilled"));
var _fuseUtils = require("@tvg/fuse-utils");
var _react = _interopRequireDefault(require("react"));
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _links = require("../../fuse-link/src/links");
var _typography = require("../../fuse-typography-element/src/typography");
var _config = require("./config");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var Container = exports.Container = _styledComponents["default"].div.attrs({
  className: 'fuse-rating'
}).withConfig({
  displayName: "styled-rating__Container",
  componentId: "sc-14zdipk-0"
})(["display:inline-flex;flex-wrap:wrap;"]);
var Stars = exports.Stars = _styledComponents["default"].div.withConfig({
  displayName: "styled-rating__Stars",
  componentId: "sc-14zdipk-1"
})(["", ""], function (_ref) {
  var rating = _ref.rating,
    size = _ref.size;
  var _buildResponsiveSize = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize2 = _slicedToArray(_buildResponsiveSize, 2),
    isResponsive = _buildResponsiveSize2[0],
    setViewportCss = _buildResponsiveSize2[1];
  var getAfterHeight = function getAfterHeight(ratingSize) {
    var _ratingCssConfig$rati;
    return "\n            height: ".concat((_ratingCssConfig$rati = _config.ratingCssConfig[ratingSize]) === null || _ratingCssConfig$rati === void 0 ? void 0 : _ratingCssConfig$rati.height, ";\n        ");
  };
  var getStarsSizeCss = function getStarsSizeCss(ratingSize) {
    var _ratingCssConfig$rati2, _ratingCssConfig$rati3;
    var height = (_ratingCssConfig$rati2 = _config.ratingCssConfig[ratingSize]) === null || _ratingCssConfig$rati2 === void 0 ? void 0 : _ratingCssConfig$rati2.height;
    // const width = parseFloat(height) * 4.8;
    // const roundedWith = width % 1 !== 0 ? width.toFixed(2) : width;
    var widthFallback = (_ratingCssConfig$rati3 = _config.ratingCssConfig[ratingSize]) === null || _ratingCssConfig$rati3 === void 0 ? void 0 : _ratingCssConfig$rati3.widthFallback;
    return "\n\t\t        height: ".concat(height, ";\n\t\t        aspect-ratio: 4.8 / 1;\n\n\t\t        @supports not (aspect-ratio: 4.8 / 1) {\n\t\t            width: ").concat(widthFallback, ";\n\t\t        }\n\t\t    ");
  };
  var setStartContainerSize = function setStartContainerSize() {
    return "\n            ".concat(isResponsive ? setViewportCss(getStarsSizeCss) : getStarsSizeCss(size), "\n        ");
  };
  var setAfterHeight = function setAfterHeight() {
    return "\n            ".concat(isResponsive ? setViewportCss(getAfterHeight) : getAfterHeight(size), "\n        ");
  };
  return "\n            position: relative;\n            display: inline-block;\n\n            ".concat(setStartContainerSize(), "\n\n            margin: 0 var(--spacing-global-space2) 0 0;\n\n            &::before,\n            &::after {\n                content: '';\n                position: absolute;\n\n                top: 0;\n                left: 0;\n                ").concat(setAfterHeight(), "\n                width: 100%;\n\n                mask-size: 20%;\n                mask-position: center;\n            }\n\n            &:before {\n                mask-image: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_Star["default"], null))), "');\n\n                background: linear-gradient(\n                    90deg,\n                    rgba(0, 0, 0, 0) 0%,\n                    rgba(0, 0, 0, 0) ").concat(rating * 20, "%,\n                    var(--color-global-grey700) ").concat(rating * 20, "%\n                );\n            }\n\n            &:after {\n                mask-image: url('data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_StarFilled["default"], null))), "');\n\n                background: linear-gradient(\n                    90deg,\n                    var(--color-brand-mid) 0%,\n                    var(--color-brand-mid) ").concat(rating * 20, "%,\n                    rgba(0, 0, 0, 0) ").concat(rating * 20, "%\n                );\n            ");
});
var setMarginBottomCss = function setMarginBottomCss(ratingSize) {
  var _ratingCssConfig$rati4;
  return "\n    margin-bottom: ".concat((_ratingCssConfig$rati4 = _config.ratingCssConfig[ratingSize]) === null || _ratingCssConfig$rati4 === void 0 ? void 0 : _ratingCssConfig$rati4.marginBottom, ";\n");
};
var getMarginBottom = function getMarginBottom(size) {
  var _buildResponsiveSize3 = (0, _fuseUtils.buildResponsiveSize)(size),
    _buildResponsiveSize4 = _slicedToArray(_buildResponsiveSize3, 2),
    isResponsive = _buildResponsiveSize4[0],
    setViewportCss = _buildResponsiveSize4[1];
  return isResponsive ? setViewportCss(setMarginBottomCss) : setMarginBottomCss(size);
};
var StyledDiv = exports.StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "styled-rating__StyledDiv",
  componentId: "sc-14zdipk-2"
})(["", " display:flex;justify-content:center;align-items:center;"], function (_ref2) {
  var size = _ref2.size;
  return getMarginBottom(size);
});
var StyledLink = exports.StyledLink = (0, _styledComponents["default"])(_links.Link).attrs({
  underline: true
}).withConfig({
  displayName: "styled-rating__StyledLink",
  componentId: "sc-14zdipk-3"
})(["white-space:nowrap;"]);
var StyledReview = exports.StyledReview = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  displayName: "styled-rating__StyledReview",
  componentId: "sc-14zdipk-4"
})(["margin:0;"]);